import Head from 'next/head';
import Link from 'next/link';
import { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import ProductGrid from '../components/product/ProductGrid';

export default function Nouveautes() {
 const t = (key) => key;
 const language = 'fr';
 const [email, setEmail] = useState('');
 const [isSubmitting, setIsSubmitting] = useState(false);
 const [latestProducts, setLatestProducts] = useState([]);
 const [loading, setLoading] = useState(true);

 useEffect(() => {
 fetchLatestProducts();
 }, []);

 const fetchLatestProducts = async () => {
 try {
 const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL || 'https://us-central1-fenparet-website.cloudfunctions.net/api'}/products/latest?limit=8`);
 const data = await response.json();

 if (data.success) {
 setLatestProducts(data.products);
 } else {
 console.error('Failed to fetch latest products:', data.message);
 }
 } catch (error) {
 console.error('Error fetching latest products:', error);
 } finally {
 setLoading(false);
 }
 };


 const handleNotifySubmit = async (e) => {
 e.preventDefault();
 if (!email) {
 toast.error('Veuillez entrer votre adresse email');
 return;
 }

 setIsSubmitting(true);
 try {
 const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL || 'https://us-central1-fenparet-website.cloudfunctions.net/api'}/newsletter/subscribe`, {
 method: 'POST',
 headers: {
 'Content-Type': 'application/json',
 },
 body: JSON.stringify({ email }),
 });

 const data = await response.json();

 if (data.success) {
 toast.success('Merci! Vous serez notifié(e) des nouveaux produits');
 setEmail('');
 } else {
 toast.error(data.message || 'Erreur lors de l\'inscription');
 }
 } catch (error) {
 console.error('Newsletter subscription error:', error);
 toast.error('Erreur lors de l\'inscription');
 } finally {
 setIsSubmitting(false);
 }
 };

 return (
 <>
 <Head>
 <title>Nouveautés | Fenkparet</title>
 <meta name="description" content="Découvrez nos dernières nouveautés et produits récents" />
 </Head>

 <div className="min-h-screen bg-theme-primary py-20">
 <div className="max-w-6xl mx-auto px-4">
 <div className="text-center mb-12 animate-fade-in-up">
 <h1 className="text-4xl lg:text-5xl font-bold text-theme-primary mb-4">
 {language === 'fr' ? 'Nouveautés' : 'New Arrivals'}
 </h1>
 <p className="text-lg text-theme-secondary max-w-2xl mx-auto">
 {language === 'fr' ? 
 'Découvrez nos derniers produits et les dernières tendances.' :
 'Discover our latest products and newest trends.'
 }
 </p>
 </div>

 {/* Email Notification Form */}
 <div className="card-accent p-8 text-center animate-fade-in-scale mb-12">
 <div className="feature-icon-large mx-auto mb-6">
 <span className="text-3xl"></span>
 </div>
 <h2 className="text-xl font-bold text-theme-primary mb-4">
 Restez informé de nos nouveautés
 </h2>
 <p className="text-theme-secondary mb-6">
 Abonnez-vous à notre newsletter pour être notifié en premier des nouveaux produits
 </p>

 <form onSubmit={handleNotifySubmit} className="max-w-md mx-auto">
 <div className="flex gap-2">
 <input
 type="email"
 value={email}
 onChange={(e) => setEmail(e.target.value)}
 placeholder="Votre adresse email"
 className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
 disabled={isSubmitting}
 />
 <button
 type="submit"
 className="btn-primary px-6 whitespace-nowrap"
 disabled={isSubmitting}
 >
 {isSubmitting ? 'Envoi...' : 'S\'abonner'}
 </button>
 </div>
 <p className="text-sm text-gray-500 mt-2">
 Soyez le premier à découvrir nos nouveaux produits
 </p>
 </form>
 </div>

 {/* Latest Products Section */}
 {loading ? (
 <div className="text-center py-12">
 <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent-primary mx-auto"></div>
 <p className="text-theme-secondary mt-4">Chargement des nouveautés...</p>
 </div>
 ) : latestProducts.length > 0 ? (
 <div>
 <h2 className="text-2xl font-bold text-theme-primary text-center mb-8">
 Nos Dernières Nouveautés
 </h2>
 <ProductGrid products={latestProducts} />
 <div className="text-center mt-12">
 <Link href="/products" legacyBehavior>
 <a className="btn-secondary">
 Voir tous les produits
 </a>
 </Link>
 </div>
 </div>
 ) : (
 <div className="card-accent p-12 text-center">
 <div className="feature-icon-large mx-auto mb-6">
 <span className="text-3xl"></span>
 </div>
 <h2 className="text-2xl font-bold text-theme-primary mb-4">
 Nouveaux produits bientôt disponibles
 </h2>
 <p className="text-theme-secondary mb-8">
 Nous préparons de nouveaux produits incroyables pour vous. Abonnez-vous à notre newsletter pour être informé en premier!
 </p>
 <div className="flex flex-col sm:flex-row gap-4 justify-center">
 <Link href="/products" legacyBehavior>
 <a className="btn-secondary">
 Voir tous les produits
 </a>
 </Link>
 </div>
 </div>
 )}
 </div>
 </div>
 </>
 );
}